import { render, staticRenderFns } from "./SettingsTemplate.vue?vue&type=template&id=efeb3620&scoped=true&"
import script from "./SettingsTemplate.vue?vue&type=script&lang=ts&"
export * from "./SettingsTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsTemplate.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SettingsTemplate.vue?vue&type=style&index=1&id=efeb3620&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeb3620",
  null
  
)

export default component.exports